import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Box,
    Button,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

const Navbar = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const buttons = [
        { label: "Home", href: "#home" },
        { label: "About Us", href: "#about" },
        { label: "Projects", href: "#projects" },
        { label: "Contact Us", href: "#contact" },
    ];

    const buttonStyles = {
        marginRight: "2rem",
        fontSize: "1.1rem",
        fontFamily: "NexaTextDemo",
        fontWeight: 600,
        letterSpacing: 1.5,
        "&:hover": {
            backgroundColor: "#FF7911",
            color: "#fff",
        },
    };

    const handleSmoothScroll = (event, targetId) => {
        event.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            window.scrollTo({
                top: target.offsetTop,
                behavior: "smooth",
            });
        }
        setDrawerOpen(false);
    };

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    return (
        <AppBar position="static" color="default">
            <Toolbar
                style={{
                    justifyContent: "space-between",
                    display: "flex",
                }}
            >
                <Box
                    style={{
                        height: "100px",
                        width: "100px",
                        backgroundImage: "url('/img/logo-gcb.png')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginLeft: 20,
                        marginTop: 5,
                    }}
                />
                {isMobile ? (
                    <>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={toggleDrawer(true)}
                        >
                            ☰
                        </IconButton>
                        <Drawer
                            anchor="right"
                            open={drawerOpen}
                            onClose={toggleDrawer(false)}
                            sx={{
                                "& .MuiDrawer-paper": {
                                    width: "100vw",
                                    height: "100vh",
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                }}
                            >
                                <IconButton
                                    onClick={toggleDrawer(false)}
                                    sx={{
                                        position: "absolute",
                                        top: 20,
                                        right: 20,
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <List>
                                    {buttons.map((button, index) => (
                                        <ListItem
                                            button
                                            key={index}
                                            onClick={(event) =>
                                                handleSmoothScroll(
                                                    event,
                                                    button.href
                                                )
                                            }
                                            sx={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <ListItemText
                                                primary={button.label}
                                                primaryTypographyProps={{
                                                    fontSize: "1.5rem",
                                                    fontWeight: "bold",
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        </Drawer>
                    </>
                ) : (
                    <Box>
                        {buttons.map((button, index) => (
                            <Button
                                key={index}
                                color="inherit"
                                href={button.href}
                                sx={buttonStyles}
                                onClick={(event) =>
                                    handleSmoothScroll(event, button.href)
                                }
                            >
                                {button.label}
                            </Button>
                        ))}
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
